import { GetServerSideProps } from 'next';
import { Fragment } from 'react';

import { wrapper } from 'src/redux/store/store';
import { getSimplePage } from 'src/api/pageApi';
import { PageSetUpInStorageConfig, ServerSideRenderingContext } from 'types/objectTypes';
import { CustomerType } from 'constants/enums';
import { setUpPageInStore } from 'lib/page.service';
import { fileExtension } from 'lib/regexp.service';
import withMiddleware, { commonMiddleware, postCommonMiddleware } from 'src/shared/lib/middleware/combiner';
import { setDefaultCacheBehavior } from 'lib/storage.service';
import { calculateCustomerType } from 'lib/session.service';

const handler = async ({
  // @ts-ignore
  req,
  res,
  store,
  params,
  preview = false,
}: ServerSideRenderingContext): Promise<any> => {
  try {
    const session = req?.session?.getSession();
    const { slug: parametersSlug } = params || { slug: '' };
    const customerType = calculateCustomerType(req.session);
    const isAuthorized = customerType === CustomerType.EC;

    const slug = (Array.isArray(parametersSlug))
      ? parametersSlug.join('')
      : parametersSlug as string;

    if (!slug || slug.match(fileExtension)) {
      return { notFound: true };
    }

    const page = await getSimplePage({ preview, slug, customerType });

    if (!page && customerType === CustomerType.NC) {
      return {
        redirect: {
          permanent: false,
          destination: '/',
        },
      };
    }

    if (!page && customerType === CustomerType.EC) {
      return {
        redirect: {
          permanent: false,
          destination: '/echomepage',
        },
      };
    }

    const pageSetUpConfig: PageSetUpInStorageConfig = {
      page,
      session,
      slug,
      store,
      headers: req.headers,
      isAuthorized,
    };
    setUpPageInStore(pageSetUpConfig);
    setDefaultCacheBehavior(120, res);

    return { props: {} };
  } catch (e) {
    console.error(e);

    return { props: {} };
  }
};

export const getServerSideProps: GetServerSideProps = wrapper
// @ts-ignore
  .getServerSideProps(withMiddleware(
    handler,
    { prior: commonMiddleware, post: postCommonMiddleware },
  ));

export default Fragment;
